import React from 'react';
import Radio from './Radio';
import autobind from '../../../js-helpers/autobind'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';

export default class RadioGroup extends React.Component {

  constructor({radios}) {
    super();

    this.state = {
      radios,
    };
  }

  componentWillReceiveProps({radios}) {
    this.setState({radios});
  }

  @autobind
  onRadioChange(evt) {
    const checkedValue = evt.target.value;
    const radios = this.state.radios.map((radio) => {
      const newRadio = radio;
      newRadio.checked = (newRadio.value === checkedValue);
      return newRadio;
    });
    this.setState({radios});
  }

  render() {
    const nodes = this.state.radios.map((props, idx) => (
      <li key={idx}>
        <Radio
          {...props}
          name={this.props.name}
          onChange={this.onRadioChange}
        />
      </li>
    ));

    return (
      <div className="form__group">
        {
          this.props.label ?
          <label className="form__desc-label"><strong>{this.props.label}</strong></label> : null
        }
        <ul className="list--inline">
          {nodes}
        </ul>
      </div>
    );
  }
}

Radio.propTypes = {
  onChange: PropTypes.any,
};
